//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";

export default {
  data() {
    return {
      products: [],
      placement: 0,
      columns: [
        {
          name: "index",
          align: "left",
          label: "Plassering",
          field: "index",
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produkt navn",
          field: "productName",
          sortable: true,
        },
        {
          name: "totalQuantity",
          align: "left",
          label: "Antall solgt",
          field: "totalQuantity",
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.getProducts();
  },

  methods: {
    ...mapActions("main", ["getTop10Products"]),

    async getProducts() {
      this.products = await this.getTop10Products();

      for(var i = 1; i < this.products.length + 1; i++) {
          this.products[i - 1].index = i;
      }
    },
  },
};
